module.exports = "#apply {\r\n    padding-top: 22px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/vehicles/vehicle-expenses/vehicle-expenses.component.css
// module id = ./src/app/components/vehicles/vehicle-expenses/vehicle-expenses.component.css
// module chunks = main